import ModelEditModal from './ModelEditModal';
import './ModelEditModal.scss';

export default ModelEditModal;
